import {
  Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectorRef, AfterViewInit
} from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';

import { AppFacade } from '@app/app.facade';
import {
  HeaderWidget, HeaderWidgetConfig, HeaderWidgetType
} from '@design-system/components/templates/header/entities/header.types';
import {
  DropDownViewCloseType, DropDownViewCloseAction, DropDownViewSlide
} from '@ux/components/drop-down-view/entities/drop-down-view.types';

@Component({
  selector: 'app-drop-down-view',
  templateUrl: './drop-down-view.component.html',
  styleUrls: ['./drop-down-view.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DropDownViewComponent implements OnChanges, AfterViewInit {

  @Input() closeType = DropDownViewCloseType.DropDown;
  @Input() closeAction = DropDownViewCloseAction.Close;
  @Input() slide = DropDownViewSlide.Left;
  @Input() closeJustInCase = true;
  @Input() defaultState = false;
  @Input() showFooter = false;
  @Input() title: string;
  @Input() skeleton = false;
  @Input() autoHeight: boolean = false

  @Output() closeEvent: EventEmitter<void> = new EventEmitter<void>();

  public animated$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public animatedDelay$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  private readonly slideMS = 600;

  constructor(
    private readonly appFacade: AppFacade,
    private readonly cdr: ChangeDetectorRef,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.defaultState) {
      this.animatedDelay$.asObservable().pipe(
        tap((animatedDelay) => {
          if (this.closeType === DropDownViewCloseType.DropDown) {
            this.animated$?.next(changes?.defaultState?.currentValue);
            if (!animatedDelay && changes?.defaultState?.currentValue) {
              this.animatedDelay$.next(changes?.defaultState?.currentValue);
            }
          } else if (!changes?.defaultState?.currentValue && this.closeType === DropDownViewCloseType.Route) {
            this.close();
          }
        })
      ).subscribe().unsubscribe();
    }
  }

  ngAfterViewInit(): void {
    if (this.closeType === DropDownViewCloseType.Route) {
      setTimeout(() => {
        this.animated$?.next(true);
        this.animatedDelay$.next(true);
      });
    }
  }

  get headerWidgets(): HeaderWidgetConfig[] {
    return [
      this.closeAction === DropDownViewCloseAction.Back && {
        Type: HeaderWidgetType.Back,
      },
      {
        Type: HeaderWidgetType.Title,
        Label: this.title,
        LabelAlign: 'center'
      },
      this.closeAction === DropDownViewCloseAction.Close && {
        Type: HeaderWidgetType.Close,
      },
    ];
  }

  public close(): void {
    if (this.closeJustInCase) {
      this.animated$?.next(false);
      this.closeEvent.emit();
      setTimeout(() => {
        if (this.closeType === DropDownViewCloseType.Route) {
          this.appFacade.navigateToLastRoute();
        }
        this.animatedDelay$.next(false);
        this.cdr.detectChanges();
      }, this.slideMS);
    }
  }

  public headerWidgetAction(widget: HeaderWidget): void {
    if (widget.Type === HeaderWidgetType.Back || widget.Type === HeaderWidgetType.Close) {
      this.close();
    }
  }

}
